import React, { useState, useContext } from "react"
import { UserContext } from "../../../context/userContext"
import _ from "lodash"
import styles from "../../../styles/Page-with-Sidebar.module.css"
import gMessages from "../../../styles/GlobalMessages.module.css"
import gql from "graphql-tag"
import { useQuery } from "@apollo/client"
import LeftChatConvList from "./LeftChatConvList"
import TRChatMessagesIndex from "../Chat Messages/TRChatMessagesIndex"
import ParticipantNewChat from "./ParticipantNewChat"
import LoaderFullPage from "../../../components/Loaders"
import { ReactComponent as NoChatsIcon } from "../resources/no_chats_icon.svg"
import { Button } from "primereact/button"
import { sortListByDate } from "../Utils"

export default function MyChatMessagesTab() {
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [participants, setParticipants] = useState(null)
  const [hasConvs, setHasConvs] = useState(null)
  const [newParticipantChat, setNewParticipantChat] = useState(false)
  const [selectedConv, setSelectedConv] = useState(null)
  const [convList, setConvList] = useState(null)

  const GET_PARTICIPANTS = gql`
  query ParticipantsSidebar(
    $staff_id: ID!
    $organization_id: ID!
    $searchType: String
  ) {
    participants: getAllActiveParticipants(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: $searchType
    ) {
      participant_id
      participant_name_first
      participant_name_last
      participant_phone_primary
    }
  }
`
  //what happen if a participant is not active anymore?
  const { loading } = useQuery(GET_PARTICIPANTS, {
    variables: {
      staff_id: user.staff_id,
      organization_id: user.organization_id,
      searchType: "all_participants"
    },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setParticipants(
        _.map(data.participants, (participant) => {
          return {
            ...participant,
            name: `${_.unescape(
              participant.participant_name_first
            )} ${_.unescape(participant.participant_name_last)}`,
            initials: `${_.unescape(participant.participant_name_first).charAt(0)}${_.unescape(participant.participant_name_last).charAt(0)}`
          }
        })
      )
    },
  })

  const onNewChatMessageSent = (conv) => {
    setSelectedConv({ sid: conv.sid, participant: { name: conv.caseName, initials: conv.caseInitials, id: conv.caseId } })
    setConvList([conv, ...convList])
    setHasConvs(true)
    setNewParticipantChat(false)
  }

  const updateConv = (newMsg) => {
    let updatedConvs = convList.map((conv) => {
      if (conv.caseId === newMsg.fromId) {
        return {
          ...conv,
          lastMessageAt: newMsg.dateUpdated,
          containsUnread: (selectedConv.participant.id !== newMsg.fromId) ? true : conv.containsUnread
        }
      } else if (selectedConv.sid === conv.sid && newMsg.fromId === user.staff_id) {
        return {
          ...conv,
          lastMessageAt: newMsg.dateUpdated
        }
      }
      return conv
    })
    sortListByDate(updatedConvs, "lastMessageAt")
    setConvList(updatedConvs)
  }

  if (loading) {
    return <LoaderFullPage />
  }

  if (convList && !newParticipantChat && !hasConvs && !selectedConv) {
    return (
      <div className={gMessages.wrapperNoChats}>
        <NoChatsIcon />
        <h3>
          Start a conversation now
        </h3>
        <Button
          className={`custom_button_icon ${gMessages.newChatBtn}`}
          style={{ marginTop: "30px" }}
          label="New Message"
          icon="pi pi-plus"
          onClick={() => setNewParticipantChat(true)} />
      </div>
    )
  }

  return (
    <div className={styles.wrapper} style={{ minHeight: "600px", margin: "0px" }}>
      {participants && (
        <LeftChatConvList
          participants={participants}
          openNewParticipantChat={() => {
            setNewParticipantChat(true)
            setSelectedConv(null)
          }}
          openConv={(conv) => {
            setSelectedConv(conv)
            setNewParticipantChat(false)
          }}
          setHasConvs={setHasConvs}
          convList={convList}
          setConvList={setConvList}
        />
      )}
      {!newParticipantChat &&
        hasConvs &&
        participants &&
        selectedConv &&
        <TRChatMessagesIndex selectedConv={selectedConv} onNewMessage={updateConv}></TRChatMessagesIndex>
      }
      {newParticipantChat && (
        <ParticipantNewChat
          onMessageSent={onNewChatMessageSent}
          participants={participants.filter((p) => !convList.some(c => c.caseId === p.participant_id))}
        />
      )}
    </div >
  )
}
